import React from 'react'
import './style/absme.css'
import profileimg from '../../Global/assets/pfimg.png'

const AboutMe = () => {
    return (
        <>
            <div style={{
                // width: '100%',
                // height: '70vh',
                // display: 'flex',
                // flexDirection: 'row',
                // justifyContent: 'center',
                // // backgroundColor:'#191919',
                // alignItems: 'center'
            }} className='abBody'>

                {/* <div className='pfimg' style={{
                    // width: '40%',
                    // height: '100%',
                    // positions: 'absloute',
                    // display: 'flex',
                    // flexDirection: 'column',
                    // justifyContent: 'center',
                    // alignItems: 'center'
                }}>
                    <img src={profileimg} alt="image" style={{
                        // width:'75%',
                        // height:'90%',
                        // borderRadius:'1vw'
                    }} className="pfimgmain" />
                </div> */}

                <div style={{
                    // width: '60%',
                    // height: '100%',
                    // positions: 'absloute',
                    // color:'#ffffff',
                    // display: 'flex',
                    // flexDirection: 'column',
                    // justifyContent: 'center',
                    // alignItems: 'flex-start',
                    // padding:'1vw'
                    
                }} className="pfcontent">
                    <h1 className="h1">About Me</h1><br />
                    <p style={{
                        lineHeight:'4vh'
                    }} className="h6">👋🏻 Hello There, <br />
                                        I am Aditya Bagari, I am 15  year old. <br />
                                        I am a student of Class 10 at D.A.V. Public School, New Shimla. <br />
                                        I live at Shimla, Himachal Pradesh. <br />
                                        I like to code, write blogs, meet people, learn different things/skills,
                                        colloborate with people, travel, explore new places.<br />
                                        I am intrested in Photography. <br />
                                        I stay active on social media most of the time. <br />
                    </p>

                </div>

            </div>
        </>
    )
}

export { AboutMe }